

















import {Component, Prop, Vue} from "vue-property-decorator";
import PlanModal from "./PlanModal.vue";
import {Country} from "@/interfaces/entities/CustomerProfile";

@Component({
    components: {PlanModal}
})
export default class CountriesModal extends Vue {
    @Prop({required: true}) regionLabel!: string;
    @Prop({type: Array, default: () => []}) includedCountries!: Array<Country>;

    get countryCount(): number {
        return this.includedCountries.length;
    }
}
